// extracted by mini-css-extract-plugin
export default {"hidestyle":"src_hidestyle__FiMBs","disablelink":"src_disablelink__mBnOr"};